import _defineProperty from "/builds/hooxitech/polgozar-front-end/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
// ========================= Placeholder ==========================
var genEmptyStyle = function genEmptyStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-tbody > tr").concat(componentCls, "-placeholder"), {
    textAlign: 'center',
    color: token.colorTextDisabled,
    '&:hover > td': {
      background: token.colorBgContainer
    }
  }));
};
export default genEmptyStyle;